import gql from "graphql-tag";

export default {
  addSubjectToBook: gql`
    mutation addSubjectLocalBook($input: addSubjectLocalBookInput!) {
      addSubjectLocalBook(input: $input) {
        localBook {
          id
          subjects(first: 20) {
            edges {
              node {
                id
                _id
                heading
                code
                subjectScheme {
                  id
                  heading
                }
              }
            }
          }
        }
      }
    }
  `,
  
  removeSubjectFromBook: gql`
    mutation removeSubjectLocalBook($input: removeSubjectLocalBookInput!) {
      removeSubjectLocalBook(input: $input) {
        localBook {
          id
          subjects(first: 20) {
            edges {
              node {
                id
                _id
                heading
                code
                subjectScheme {
                  id
                  heading
                }
              }
            }
          }
        }
      }
    }
  `
};
